import { Component } from '@angular/core';

@Component({
  selector: 'bc-logged-out-page',
  templateUrl: './logged-out-page.component.html',
  styleUrls: ['./logged-out-page.component.scss']
})
export class LoggedOutComponent {
}
